import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取地址列表
export function getMailingAddressList(params) {
  return request({
    url: URL.mdm.mailingAddress.mailingAddressInfo,
    method: 'get',
    params
  })
}

// 通过uuid获取收发通地址,用于编辑前查值
export function findMailingAddressByUuid(uuid) {
  const params = { uuid }
  return request({
    url: URL.mdm.mailingAddress.mailingAddressDetail,
    method: 'get',
    params
  })
}

export function addMailingAddress(data) {
  return request({
    url: URL.mdm.mailingAddress.mailingAddressInfo,
    method: 'post',
    data
  })
}

export function updateMailingAddress(data) {
  return request({
    url: URL.mdm.mailingAddress.mailingAddressInfo,
    method: 'put',
    data
  })
}

// 删除收费项目
export function batchDelMailingAddress(data) {
  return request({
    url: URL.mdm.mailingAddress.mailingAddressInfo,
    method: 'delete',
    data
  })
}

export function checkBillAddress(data) {
  return request({
    url: URL.mdm.mailingAddress.checkBillAddress,
    method: 'put',
    data
  })
}

// 获取地址明细列表
export function queryAddressList(params) {
  return request({
    url: URL.mdm.mailingAddress.queryAddressList,
    method: 'get',
    params
  })
}

// 获取付款方地址明细
export function queryPaymentAddressFunc(data) {
  return request({
    url: URL.mdm.mailingAddress.queryPaymentAddressUrl,
    method: 'post',
    data
  })
}

export function sendAddressByManifest(data) {
  return request({
    url: URL.mdm.mailingAddress.sendAddressByManifest,
    method: 'post',
    data
  })
}
